$(function() {  				
	$('.change-view-cta').on('click', function () {					
		$('.change-view-cta').toggleClass('change-cta');					
		$('.list-view-result').toggleClass('map-view-result');	
        $('body').trigger('refreshMap')				;
	});
});



$(function(){    
    $(".filter-grid .select--wrapper--title").on("click", function() {

        var index = $(this).index(".select--wrapper--title");

        if ($(".select--wrapper.open").length >= 1) {
            
            if ($(this).parents(".select--wrapper").hasClass("open")) {
                
                $(".filter-grid .select--wrapper.open").removeClass("open");

            } else {
                //Close other filter boxes if open
                $(".filter-grid .select--wrapper.open").removeClass("open");
                $(".filter-grid .select--wrapper").eq(index).addClass("open");   
            }

        } else {
            $(".filter-grid .select--wrapper").eq(index).addClass("open");        
        }            
    })
    //
    $('section#availableAccomodation .select--wrapper--dropdown .checkbox').each(function() {
        $(this).on('click', function(e) {
          const target = $(e.target);
          const name = target.next().html();
          console.log(target.parent().parent().prev());
          target.parent().parent().prev().find('span').html(name);
        });
      });

    // close the dropdown when the user clicks outside of it
    $(document).on("click", function(e) {
        if (!$(e.target).closest(".select--wrapper").length) {
        $(".filter-grid .select--wrapper").removeClass("open");
        }
    });
});

//Trail list filter
$(function() {
    var trailFilterBtn = $(".trail-filter button");
    var trailFilterItems = $(".trail-filter__list li");
    var trailFilterClear = $(".trail-filter__clear");

    trailFilterBtn.on("click", function() {
        $(this).toggleClass("open");
    });

    trailFilterItems.on("click", function() {
        $(trailFilterItems, ".active").removeClass("active");
        $(this).addClass("active");

        if ($(trailFilterItems, ".active").length) {
            trailFilterClear.show();
        } else {
            trailFilterClear.hide();
        }
    })

    trailFilterClear.on("click", function() {
        trailFilterItems.removeClass("active");
        trailFilterBtn.removeClass("open");
        $(this).hide();
    })

    //Close filter list on click off button
    $(document).on("click", function(e) {
        
        if (!trailFilterBtn.is(e.target) || !trailFilterBtn.has(e.target)) {
            trailFilterBtn.removeClass("open")
        }

    })
})